
import React from "react";
import "./Radio.css";

export type RadioProps = {
    name: string;
    choices: string[];
    choice: string;
    sorted?: boolean;
    disabled?: boolean;
    variant?: "primary" | "secondary" | "tertiary";
    size?: "sm" | "md" | "lg";
    className?: string;
    onChange: (choice: string) => void;
    children?: React.ReactNode;
};

export const Radio = ({
    name,
    choices,
    choice,
    sorted = false,
    disabled = false,
    variant = "primary",
    size = "sm",
    className,
    onChange,
    children,
    ...props
}: RadioProps 
// & React.ComponentPropsWithoutRef<"div">
) => {

    const sortedChoices = sorted ? choices.sort((a: string, b: string) => a.localeCompare(b)) : choices;

    const getVariantClass = () => {
        switch (variant) {
            case "primary":
                return "ds2-radio-primary";
            case "secondary":
                return "ds2-radio-secondary";
            case "tertiary":
                return "ds2-radio-tertiary";
            default:
                return "ds2-radio-primary";
        }
    }

    const getSizeStyles = () => {

        switch (size) {
            case "sm":
                return {height: "16px", width: "24px", minWidth: "24px", fontSize: "1rem", outline: "none"};
            case "md":
            case "lg":
            default:
                return {height: "24px", width: "40px", minWidth: "40px", fontSize: "1.25rem"};
        }
    }

    // const getInnerSizeStyles = () => {
    
    //     switch (size) {
    //         case "sm":
    //             return {padding: "0px", gap: "2px", fontSize: ".85rem"};
    //         case "md":
    //         case "lg":
    //         default:
    //             return {padding: "8px 12px", gap: "4px", fontSize: "1rem"};
    //     }
    // }
    
    return (
        <div className="app-custom-property-radio">
            {sortedChoices.map((option: string, index: number) => {
                return (
                    <div 
                        key={"radio-" + index}
                        className="ds2-radio-choice"
                    >
                        <input
                            key={"radio-" + index}
                            name={name}
                            type="radio"
                            disabled={disabled} 
                            checked={choice === option}
                            className={getVariantClass() + " " + className}
                            style={{
                                ...getSizeStyles(),
                            }}
                            onChange={(event) => {
                                onChange(option);
                            }}
                            {...props} 
                        />     
                        <span>{option}</span>
                    </div>
                );
            })}
        </div>
    );
};